import { useEffect, useRef } from "react";
// `framer-motion` y no `motion/react`, que es de donde lo trae Magic UI: son
// la misma librería con dos nombres, y el proyecto ya tiene framer-motion.
// Dejar el import original sumaba una copia entera al bundle para no ganar
// nada.
import { useInView, useMotionValue, useSpring } from "framer-motion"

import { cn } from "../../lib/utils"

export function NumberTicker({
  value,
  startValue = 0,
  direction = "up",
  delay = 0,
  className,
  decimalPlaces = 0,
  ...props
}) {
  const ref = useRef(null)
  const motionValue = useMotionValue(direction === "down" ? value : startValue)
  const springValue = useSpring(motionValue, {
    damping: 60,
    stiffness: 100,
  })
  const isInView = useInView(ref, { once: true, margin: "0px" })

  useEffect(() => {
    let timer = null

    if (isInView) {
      timer = setTimeout(() => {
        motionValue.set(direction === "down" ? startValue : value)
      }, delay * 1000)
    }

    return () => {
      if (timer !== null) {
        clearTimeout(timer)
      }
    };
  }, [motionValue, isInView, delay, value, direction, startValue])

  useEffect(() =>
    springValue.on("change", (latest) => {
      if (ref.current) {
        ref.current.textContent = Intl.NumberFormat("es-AR", {
          minimumFractionDigits: decimalPlaces,
          maximumFractionDigits: decimalPlaces,
        }).format(Number(latest.toFixed(decimalPlaces)))
      }
    }), [springValue, decimalPlaces])

  return (
    <span
      ref={ref}
      className={cn(
        // Sin color propio: hereda el de donde esté. Este número vive adentro
        // de una píldora roja y de un cartel gris, y un negro fijo lo rompe en
        // los dos.
        "inline-block tabular-nums",
        className
      )}
      {...props}>
      {startValue}
    </span>
  );
}
